<template>
	<ViewPhoto
		:key="photosIndex"
		v-if="imageShow && images.length"
		:images="images"
		:index="photosIndex"
		@close="imageShow = false"
	/>
	<input
		type="file"
		hidden
		id="upload-images-notification-detail"
		multiple
		@change="uploadChange"
		accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpeg, image/jpg"
	/>
	<DaModalFrame v-model:open="open">
		<Withdraw v-if="open" @close="cancel" @submit="withdrawNotification" />
	</DaModalFrame>
	<DaModalFrame v-model:open="modalIsOpen">
		<DeleteConfirm
			v-if="modalType === type.DELETE"
			@close="cancel"
			@submit="deleteNotification"
		/>
		<ConfirmSend
			v-if="modalType === type.CREATE"
			@close="cancel"
			@submit="sendNotification"
			@openViewPhoto="openMediaPopup(0)"
			:notification="{
				...notification,
				files,
				images,
				isImage: isImageType,
			}"
			is-network
			:in-progress="inProgress"
		/>
		<ReSend
			v-if="modalType === type.RESEND"
			@close="cancel"
			@submit="resendNotification"
			:notification="notification"
		/>
	</DaModalFrame>
	<div class="pb-30 px-10 md-down:px-4">
		<div
			class="__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between md:items-center gap-8 md-down:flex-col md-down:gap-6"
		>
			<div
				class="__record__title text-neutral-500 font-semibold flex flex-nowrap items-center text-4xl cursor-pointer"
				@click="$router.push('/notifications')"
			>
				<svg
					class="mr-2"
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M17.5 7L10.5 14L17.5 21"
						stroke="#94A3B8"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				<div>
					{{ title }}
				</div>
			</div>

			<div
				class="flex items-center md:justify-end gap-8"
				v-if="notification.state === 'draft'"
			>
				<div
					@click="deleteOpen"
					class="flex items-center text-yellow-600 hover:text-yellow-700 font-semibold cursor-pointer text-sm"
				>
					<svg
						class="mr-2"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
							fill="currentColor"
						/>
					</svg>
					<span class="mt-0.5">Xoá</span>
				</div>
				<div
					v-if="isEdit"
					@click="update"
					class="flex items-center text-yellow-600 hover:text-yellow-700 font-semibold cursor-pointer text-sm"
				>
					<svg
						class="mr-2"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M11.3333 2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V4.66667L11.3333 2ZM8 12.6667C6.89333 12.6667 6 11.7733 6 10.6667C6 9.56 6.89333 8.66667 8 8.66667C9.10667 8.66667 10 9.56 10 10.6667C10 11.7733 9.10667 12.6667 8 12.6667ZM10 6H3.33333V3.33333H10V6Z"
							fill="currentColor"
						/>
					</svg>
					<span class="mt-0.5">Lưu chỉnh sửa</span>
				</div>
				<div
					v-if="!isEdit"
					@click="edit"
					class="flex items-center text-yellow-600 hover:text-yellow-700 font-semibold cursor-pointer text-sm"
				>
					<svg
						class="mr-2"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M12.4702 6.65078L13.7102 5.41075C13.8461 5.27489 13.914 5.20696 13.9667 5.14499C14.6009 4.39832 14.6009 3.30214 13.9667 2.55546C13.914 2.4935 13.8461 2.42557 13.7102 2.28971C13.5744 2.15385 13.5064 2.08592 13.4445 2.03329C12.6978 1.39906 11.6016 1.39906 10.855 2.03329C10.793 2.08591 10.7251 2.15382 10.5893 2.28961L10.5892 2.28969L10.5892 2.28971L9.33099 3.54792C10.0747 4.84212 11.1583 5.91739 12.4702 6.65078ZM7.87633 5.00258L2.86273 10.0162C2.43767 10.4412 2.22514 10.6538 2.0854 10.9149C1.94567 11.176 1.88672 11.4707 1.76883 12.0601L1.37318 14.0384C1.30666 14.371 1.27339 14.5373 1.368 14.6319C1.46261 14.7266 1.62892 14.6933 1.96153 14.6268L3.9398 14.2311L3.93982 14.2311L3.93984 14.2311C4.52927 14.1132 4.82399 14.0543 5.08508 13.9145C5.34617 13.7748 5.55869 13.5623 5.98373 13.1373L5.98376 13.1372L5.98377 13.1372L11.0118 8.10922C9.7511 7.31101 8.68202 6.24913 7.87633 5.00258Z"
							fill="currentColor"
						/>
					</svg>
					<span class="mt-0.5">Chỉnh sửa</span>
				</div>
			</div>
			<div
				class="flex items-center md:justify-end gap-8"
				v-else-if="notification.state === 'withdrawn'"
			>
				<div
					class="w-full md:w-30 bg-white p-3 rounded-lg border shadow-sm border-neutral-200 flex items-center md-down:mt-6"
				>
					<svg
						width="19"
						height="20"
						viewBox="0 0 19 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M1.65217 0C0.739703 0 0 0.746192 0 1.66667V18.3333C0 19.2538 0.739704 20 1.65217 20H9.67212C8.30012 18.7784 7.43478 16.9231 7.43478 14.9319C7.43478 11.25 10.3936 8.33333 14.0435 8.33333C14.9199 8.33333 15.7564 8.50542 16.5217 8.81793V1.66667C16.5217 0.746192 15.782 0 14.8696 0H1.65217ZM1.65217 7.08333C1.42406 7.08333 1.23913 7.26988 1.23913 7.5C1.23913 7.73012 1.42406 7.91667 1.65217 7.91667H9.5C9.72812 7.91667 9.91304 7.73012 9.91304 7.5C9.91304 7.26988 9.72812 7.08333 9.5 7.08333H1.65217ZM1.65217 9.58333C1.42406 9.58333 1.23913 9.76988 1.23913 10C1.23913 10.2301 1.42406 10.4167 1.65217 10.4167H7.84783C8.07594 10.4167 8.26087 10.2301 8.26087 10C8.26087 9.76988 8.07594 9.58333 7.84783 9.58333H1.65217ZM1.65217 12.0833C1.42406 12.0833 1.23913 12.2699 1.23913 12.5C1.23913 12.7301 1.42406 12.9167 1.65217 12.9167H6.19565C6.42377 12.9167 6.6087 12.7301 6.6087 12.5C6.6087 12.2699 6.42377 12.0833 6.19565 12.0833H1.65217ZM1.65217 14.5833C1.42406 14.5833 1.23913 14.7699 1.23913 15C1.23913 15.2301 1.42406 15.4167 1.65217 15.4167H4.54348C4.7716 15.4167 4.95652 15.2301 4.95652 15C4.95652 14.7699 4.7716 14.5833 4.54348 14.5833H1.65217ZM2.06522 2.91667C1.60898 2.91667 1.23913 3.28976 1.23913 3.75C1.23913 4.21024 1.60898 4.58333 2.06522 4.58333H13.2174C13.6736 4.58333 14.0435 4.21024 14.0435 3.75C14.0435 3.28976 13.6736 2.91667 13.2174 2.91667H2.06522Z"
							fill="#E37056"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M14.0435 20C16.7809 20 19 17.7614 19 15C19 12.2386 16.7809 10 14.0435 10C11.3061 10 9.08696 12.2386 9.08696 15C9.08696 17.7614 11.3061 20 14.0435 20ZM11.5652 15C11.5652 14.7699 11.7501 14.5833 11.9783 14.5833H16.3152C16.5433 14.5833 16.7283 14.7699 16.7283 15C16.7283 15.2301 16.5433 15.4167 16.3152 15.4167H11.9783C11.7501 15.4167 11.5652 15.2301 11.5652 15Z"
							fill="#E37056"
						/>
					</svg>
					<div
						class="ml-2 text-sm text-neutral-600 whitespace-nowrap"
					>
						Đã thu hồi
					</div>
				</div>
			</div>
			<div v-else class="flex items-center md:justify-end gap-4">
				<div
					class="w-full md:w-30 bg-white p-3 rounded-lg border shadow-sm border-neutral-200 flex items-center md-down:mt-6"
				>
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10.2916 8.00004C10.2916 9.26569 9.26561 10.2917 7.99996 10.2917C6.73431 10.2917 5.70829 9.26569 5.70829 8.00004C5.70829 6.73439 6.73431 5.70837 7.99996 5.70837C9.26561 5.70837 10.2916 6.73439 10.2916 8.00004Z"
							fill="#94A3B8"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.666626 8.00004C0.666626 8.00004 3.41663 2.95837 7.99996 2.95837C12.5833 2.95837 15.3333 8.00004 15.3333 8.00004C15.3333 8.00004 12.5833 13.0417 7.99996 13.0417C3.41663 13.0417 0.666626 8.00004 0.666626 8.00004ZM7.99996 11.2084C9.77187 11.2084 11.2083 9.77195 11.2083 8.00004C11.2083 6.22813 9.77187 4.79171 7.99996 4.79171C6.22805 4.79171 4.79163 6.22813 4.79163 8.00004C4.79163 9.77195 6.22805 11.2084 7.99996 11.2084Z"
							fill="#94A3B8"
						/>
					</svg>
					<div
						class="ml-2 text-sm text-neutral-600 font-semibold whitespace-nowrap"
					>
						{{ notification.view_count }}
						{{ notification.is_notice_for_parent ? 'PH' : $filters.terminology('teacher_short_name') }}
						đã xem
					</div>
				</div>
				<div
					class="w-full md:w-30 bg-white p-3 rounded-lg border shadow-sm border-neutral-200 flex items-center md-down:mt-6"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M17.4729 3.29087L12.482 17.2255C12.4224 17.3902 12.2661 17.4999 12.091 17.5H11.9579C11.7946 17.5 11.6458 17.4061 11.5753 17.2587L9.61218 13.0992C9.32311 12.4859 9.435 11.7586 9.895 11.2606L12.3905 8.53194C12.5436 8.37126 12.5436 8.1186 12.3905 7.95792L12.0744 7.64179C11.9137 7.48861 11.6611 7.48861 11.5004 7.64179L8.77204 10.1375C8.27411 10.5976 7.54687 10.7095 6.9337 10.4204L2.77457 8.45707C2.61418 8.39667 2.50588 8.24569 2.50007 8.07439V7.94128C2.48534 7.7541 2.59781 7.58026 2.77457 7.517L16.7077 2.5255C16.8575 2.47049 17.0255 2.50605 17.1402 2.61701L17.3565 2.83331C17.4865 2.94689 17.5328 3.12896 17.4729 3.29087Z"
							fill="#2AA797"
						/>
					</svg>
					<div
						class="ml-2 text-sm text-neutral-600 whitespace-nowrap"
					>
						Thông báo đã gửi
					</div>
				</div>
			</div>
		</div>
		<div class="bg-white rounded-xl p-6 shadow-sm">
			<div class="flex justify-between items-center">
				<div class="text-gray-600 font-semibold text-lg">
					Nội dung thông báo
				</div>
				<div
					class="cursor-pointer flex items-center"
					v-if="notification.state === 'draft'"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2.49992 0C1.57944 0 0.833252 0.746192 0.833252 1.66667V18.3333C0.833252 19.2538 1.57944 20 2.49992 20H10.5902C9.20618 18.7784 8.33325 16.9231 8.33325 14.9319C8.33325 11.25 11.318 8.33333 14.9999 8.33333C15.884 8.33333 16.7279 8.50542 17.4999 8.81793V1.66667C17.4999 0.746192 16.7537 0 15.8333 0H2.49992ZM2.49992 7.08333C2.2698 7.08333 2.08325 7.26988 2.08325 7.5C2.08325 7.73012 2.2698 7.91667 2.49992 7.91667H10.4166C10.6467 7.91667 10.8333 7.73012 10.8333 7.5C10.8333 7.26988 10.6467 7.08333 10.4166 7.08333H2.49992ZM2.49992 9.58333C2.2698 9.58333 2.08325 9.76988 2.08325 10C2.08325 10.2301 2.2698 10.4167 2.49992 10.4167H8.74992C8.98004 10.4167 9.16658 10.2301 9.16658 10C9.16658 9.76988 8.98004 9.58333 8.74992 9.58333H2.49992ZM2.49992 12.0833C2.2698 12.0833 2.08325 12.2699 2.08325 12.5C2.08325 12.7301 2.2698 12.9167 2.49992 12.9167H7.08325C7.31337 12.9167 7.49992 12.7301 7.49992 12.5C7.49992 12.2699 7.31337 12.0833 7.08325 12.0833H2.49992ZM2.49992 14.5833C2.2698 14.5833 2.08325 14.7699 2.08325 15C2.08325 15.2301 2.2698 15.4167 2.49992 15.4167H5.41658C5.6467 15.4167 5.83325 15.2301 5.83325 15C5.83325 14.7699 5.6467 14.5833 5.41658 14.5833H2.49992ZM2.91659 2.91667C2.45635 2.91667 2.08325 3.28976 2.08325 3.75C2.08325 4.21024 2.45635 4.58333 2.91659 4.58333H14.1666C14.6268 4.58333 14.9999 4.21024 14.9999 3.75C14.9999 3.28976 14.6268 2.91667 14.1666 2.91667H2.91659Z"
							fill="#94A3B8"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M19.9999 15C19.9999 17.7614 17.7613 20 14.9999 20C12.2385 20 9.99992 17.7614 9.99992 15C9.99992 12.2386 12.2385 10 14.9999 10C17.7613 10 19.9999 12.2386 19.9999 15ZM13.3459 12.904C13.2239 12.782 13.026 12.782 12.9039 12.904C12.7819 13.0261 12.7819 13.2239 12.9039 13.346L14.558 15L12.9039 16.654C12.7819 16.7761 12.7819 16.9739 12.9039 17.096C13.026 17.218 13.2239 17.218 13.3459 17.096L14.9999 15.4419L16.6539 17.096C16.776 17.218 16.9739 17.218 17.0959 17.096C17.2179 16.9739 17.2179 16.7761 17.0959 16.654L15.4419 15L17.0959 13.346C17.2179 13.2239 17.2179 13.0261 17.0959 12.904C16.9739 12.782 16.776 12.782 16.6539 12.904L14.9999 14.5581L13.3459 12.904Z"
							fill="#94A3B8"
						/>
					</svg>
					<div
						class="ml-2 text-sm text-neutral-600 whitespace-nowrap"
					>
						Bản nháp
					</div>
				</div>
			</div>
			<div class="rounded-lg p-4 border border-gray-100 mt-4">
				<div class="flex md-down:flex-col w-full gap-4">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						Tiêu đề
					</div>
					<div class="w-full input-group" v-if="isEdit">
						<input
							class="title"
							type="text"
							placeholder="Tiêu đề thông báo"
							v-model="notification.title"
							style="border-color: #e8e8e8"
						/>
					</div>
					<div v-else class="w-full font-semibold text-gray-700">
						{{ notification.title }}
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						nội dung
					</div>
					<div v-if="isEdit" class="w-full">
						<textarea
							placeholder="Nội dung thông báo"
							v-model="notification.content"
						></textarea>
					</div>
					<div
						v-else
						class="w-full text-gray-700"
						v-html="
							formatUrl(notification.content)?.replace(
								/\n/g,
								'<br />'
							)
						"
					></div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						TỆP ĐÍNH KÈM
					</div>
					<div class="w-full">
						<div v-if="images.length || files.length" class="mb-4">
							<div
								v-if="images.length"
								class="grid grid-cols-2 gap-4"
							>
								<div
									v-for="(image, index) in images"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="absolute top-2 right-2 cursor-pointer"
										v-if="isEdit"
										@click="removeImage(index)"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g opacity="0.5">
												<rect
													width="12"
													height="12"
													rx="6"
													fill="black"
												/>
											</g>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="white"
											/>
										</svg>
									</div>
									<img
										:src="getUrl(image)"
										alt=""
										class="rounded-lg object-fill h-full w-full"
										style="aspect-ratio: 4/3"
										@click="openMediaPopup(index)"
									/>
								</div>
							</div>
							<div
								v-if="files.length"
								class="mt-4 flex flex-col gap-2"
							>
								<div
									v-for="(file, index) in files"
									:key="index"
								>
									<div
										class="text-neutral-400 flex items-center gap-2"
									>
										<svg
											width="24"
											height="32"
											viewBox="0 0 24 32"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
												fill="#E5A42B"
											/>
										</svg>
										<a
											:href="file?.asset_url"
											target="_blank"
											class="hover:underline"
										>
											{{ file.name }}</a
										>
										<span v-if="isEdit"
											><svg
												@click.stop="removeFile(index)"
												class="text-gray-400 cursor-pointer"
												width="20"
												height="20"
												viewBox="0 0 12 12"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
													fill="currentColor"
												/>
											</svg>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div v-if="isEdit" class="w-full flex items-end gap-8">
							<button
								@click="openModelUpload"
								type="button"
								class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
							>
								<svg
									class="mr-2"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M8 0C6.57359 0 5.31176 0.560456 4.40576 1.34182C3.63985 2.00237 3.08479 2.8617 2.94223 3.725C1.26586 4.09512 0 5.55511 0 7.31818C0 9.36599 1.70754 11 3.78125 11H7.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11H12.6875C14.5023 11 16 9.56949 16 7.77273C16 6.13656 14.7581 4.80411 13.1657 4.57898C12.9233 1.99944 10.6902 0 8 0Z"
										fill="currentColor"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M7.5 14.5V11H8.5V14.5C8.5 14.7761 8.27614 15 8 15C7.72386 15 7.5 14.7761 7.5 14.5Z"
										fill="currentColor"
									/>
								</svg>
								Tải lên tệp hoặc ảnh đính kèm
							</button>
						</div>
						<!-- <div
							v-else
							class="
								w-full
								text-neutral-500
								bg-gray-100
								flex flex-col
								items-center
								justify-senter
								text-center
								gap-2
								rounded-lg
								p-8
								cursor-pointer
								border-2 border-dashed
								hover:border-yellow-500
							"
							@click="openModelUpload"
						>
							<svg
								width="48"
								height="48"
								viewBox="0 0 48 48"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M24 0C19.7208 0 15.9353 1.68137 13.2173 4.02545C10.9196 6.0071 9.25438 8.5851 8.82668 11.175C3.79759 12.2853 0 16.6653 0 21.9545C0 28.098 5.12261 33 11.3438 33H22.5V17.1213L16.0607 23.5607C15.4749 24.1464 14.5251 24.1464 13.9393 23.5607C13.3536 22.9749 13.3536 22.0251 13.9393 21.4393L22.9393 12.4393C23.5251 11.8536 24.4749 11.8536 25.0607 12.4393L34.0607 21.4393C34.6464 22.0251 34.6464 22.9749 34.0607 23.5607C33.4749 24.1464 32.5251 24.1464 31.9393 23.5607L25.5 17.1213V33H38.0625C43.507 33 48 28.7085 48 23.3182C48 18.4097 44.2743 14.4123 39.4971 13.7369C38.7699 5.99831 32.0707 0 24 0Z"
									fill="currentColor"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M22.5 43.5V33H25.5V43.5C25.5 44.3284 24.8284 45 24 45C23.1716 45 22.5 44.3284 22.5 43.5Z"
									fill="currentColor"
								/>
							</svg>
							<div class="font-semibold">
								Tải lên tệp đính kèm
							</div>
							<div class="text-sm">PNG, JPG & PDF</div>
						</div> -->
						<div v-else></div>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						ĐỐI TƯỢNG
					</div>
					<div v-if="isEdit" class="w-full">
						<div class="flex gap-20 md-down:gap-8">
							<div
								class="flex items-center"
								@click="targetGroup = 'parents'"
							>
								<label class="mr-3 block text-neutral-600">
									Phụ huynh
								</label>
								<input
									name="notification-method"
									type="radio"
									class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
									value="parents"
									v-model="targetGroup"
								/>
							</div>
							<div
								class="flex items-center"
								@click="targetGroup = 'staffs'"
							>
								<label class="mr-3 block text-neutral-600">
									{{ $filters.terminology('teacher') }}
								</label>
								<input
									name="notification-method"
									type="radio"
									class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
									value="staffs"
									v-model="targetGroup"
								/>
							</div>
						</div>
						<div class="w-full mt-6">
							<Multiselect
								track-by="value"
								:searchable="true"
								:allow-empty="false"
								:options="targetOptions"
								v-model="target"
								label="text"
								selectLabel=""
								placeholder="Chọn đối tượng báo cáo"
								selectedLabel=""
								deselectLabel="Ấn đễ bỏ chọn"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
							</Multiselect>
						</div>
						<div
							class="w-full mt-6"
							v-if="
								target &&
								[
									'custom_parent_of_students',
									'custom_staffs',
								].includes(target.value)
							"
						>
							<Multiselect
								track-by="value"
								:searchable="true"
								:options="targetOptionsCustom"
								:model-value="targetCustom"
								label="text"
								selectLabel=""
								:placeholder="
									targetGroup === 'staffs'
										? `Chọn ${$filters.terminology('teacher')} nhận thông báo`
										: 'Chọn Phụ huynh nhận thông báo'
								"
								selectedLabel=""
								deselectLabel="Ấn đễ bỏ chọn"
								@select="customSelected"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
							</Multiselect>
						</div>
						<div class="mt-6" v-if="targetGroup === 'staffs'">
							<div
								class="flex items-center justify-between mt-2"
								v-for="staff in staffsSelected"
								:key="staff.value"
							>
								<div>{{ staff.text }}</div>
								<div
									@click="deleteSelected(staff)"
									class="flex items-center text-blue-600 hover:text-blue-700 font-semibold cursor-pointer text-sm"
								>
									<svg
										class="mr-2"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
											fill="currentColor"
										/>
									</svg>
									<span class="mt-0.5">Xoá</span>
								</div>
							</div>
						</div>
						<div class="mt-6" v-else>
							<div
								class="flex items-center justify-between mt-2"
								v-for="parent in parentsSelected"
								:key="parent.value"
							>
								<div>{{ parent.text }}</div>
								<div
									@click="deleteSelected(parent)"
									class="flex items-center text-blue-600 hover:text-blue-700 font-semibold cursor-pointer text-sm"
								>
									<svg
										class="mr-2"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
											fill="currentColor"
										/>
									</svg>
									<span class="mt-0.5">Xoá</span>
								</div>
							</div>
						</div>
					</div>
					<div
						v-else-if="notification?.subject == 'Tuỳ chọn'"
						class="w-full text-gray-700"
					>
						<div v-for="s in notification.students" :key="s.id">
							Phụ Huynh bé {{ s.name }}
						</div>
					</div>
					<div v-else class="w-full text-gray-700">
						{{ notification?.subject }}
					</div>
				</div>
				<div
					class="flex md-down:flex-col w-full gap-4 mt-8"
					v-if="notification.state !== 'draft'"
				>
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						gửi lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification?.sent_at">
							{{ $filters.formatDateTime(notification?.sent_at) }}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div
					class="flex md-down:flex-col w-full gap-4 mt-8"
					v-if="notification.state !== 'draft'"
				>
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						tạo lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification?.inserted_at">
							{{
								$filters.formatDateTime(
									notification?.inserted_at
								)
							}}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div
					class="flex md-down:flex-col w-full gap-4 mt-8"
					v-if="notification.state !== 'draft'"
				>
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						người gửi
					</div>
					<div class="w-full text-gray-700">
						<div
							v-if="notification.sent_by_staff"
							@click="
								isAdmin &&
									$router.push(
										`/record/employee/${notification.sent_by_staff.id}`
									)
							"
							:class="{
								'cursor-pointer': isAdmin,
							}"
						>
							<div class="flex items-center">
								<img
									class="shadow-sm inline-block h-6 w-6 rounded-full"
									:src="
										notification.sent_by_staff
											?.profile_photo?.w200
									"
									v-if="
										notification.sent_by_staff
											?.profile_photo?.w200
									"
									alt=""
								/>
								<span
									v-else
									class="inline-flex items-center justify-center h-6 w-6 rounded-full"
									:style="{
										background:
											notification.sent_by_staff
												?.profile_photo?.default?.color,
									}"
								>
									<span
										class="font-medium leading-none text-white text-xs"
										>{{
											notification.sent_by_staff
												?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div class="ml-4 text-blue-600 font-semibold">
									{{ notification.sent_by_staff?.name }}
								</div>
							</div>
						</div>
						<div v-else>-</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-10 flex items-center justify-end gap-6">
			<div
				class="flex items-center gap-1 cursor-pointer"
				@click="confirmWithdrawOpen"
				v-if="notification.state !== 'withdrawn' && !isEdit"
			>
				<svg
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6.00007 4.06758e-07C4.95912 -0.000350034 3.93598 0.270125 3.0312 0.784848C2.12641 1.29957 1.37111 2.04083 0.839493 2.9358C0.30788 3.83077 0.0182515 4.84864 -0.000933756 5.88942C-0.020119 6.93019 0.231799 7.95805 0.730067 8.872L0.020067 11.362C-0.00491574 11.4494 -0.0055812 11.542 0.0181421 11.6298C0.0418654 11.7176 0.0890792 11.7972 0.154702 11.8602C0.220325 11.9231 0.301872 11.967 0.390568 11.9871C0.479263 12.0071 0.571747 12.0026 0.658067 11.974L2.99607 11.195C3.46407 11.466 3.97207 11.675 4.50907 11.813C4.03457 10.7907 3.88561 9.64722 4.08236 8.53743C4.27911 7.42764 4.81207 6.4051 5.60909 5.60818C6.40612 4.81126 7.42874 4.27845 8.53856 4.08185C9.64837 3.88525 10.7918 4.03436 11.8141 4.509C11.483 3.21864 10.732 2.07514 9.67931 1.25875C8.62664 0.442363 7.33221 -0.000489938 6.00007 4.06758e-07ZM9.50007 14C10.091 14 10.6762 13.8836 11.2221 13.6575C11.7681 13.4313 12.2642 13.0998 12.682 12.682C13.0999 12.2641 13.4314 11.768 13.6575 11.2221C13.8837 10.6761 14.0001 10.0909 14.0001 9.5C14.0001 8.90905 13.8837 8.32389 13.6575 7.77793C13.4314 7.23196 13.0999 6.73588 12.682 6.31802C12.2642 5.90016 11.7681 5.56869 11.2221 5.34254C10.6762 5.1164 10.091 5 9.50007 5C8.30659 5 7.162 5.47411 6.31809 6.31802C5.47417 7.16193 5.00007 8.30653 5.00007 9.5C5.00007 10.6935 5.47417 11.8381 6.31809 12.682C7.162 13.5259 8.30659 14 9.50007 14ZM8.60407 7.604L7.70707 8.5H9.25007C9.6112 8.5 9.9688 8.57113 10.3024 8.70933C10.6361 8.84753 10.9392 9.05009 11.1946 9.30546C11.45 9.56082 11.6525 9.86397 11.7907 10.1976C11.9289 10.5313 12.0001 10.8889 12.0001 11.25V11.5C12.0001 11.6326 11.9474 11.7598 11.8536 11.8536C11.7599 11.9473 11.6327 12 11.5001 12C11.3675 12 11.2403 11.9473 11.1465 11.8536C11.0527 11.7598 11.0001 11.6326 11.0001 11.5V11.25C11.0001 10.7859 10.8157 10.3408 10.4875 10.0126C10.1593 9.68437 9.7142 9.5 9.25007 9.5H7.70707L8.60407 10.396C8.69795 10.4899 8.7507 10.6172 8.7507 10.75C8.7507 10.8828 8.69795 11.0101 8.60407 11.104C8.51018 11.1979 8.38284 11.2506 8.25007 11.2506C8.11729 11.2506 7.98995 11.1979 7.89607 11.104L6.14407 9.35C6.05121 9.25605 5.99929 9.12918 5.99967 8.99709C6.00004 8.86499 6.05268 8.73842 6.14607 8.645L7.89607 6.895C7.94255 6.84851 7.99774 6.81164 8.05848 6.78648C8.11922 6.76132 8.18432 6.74837 8.25007 6.74837C8.31581 6.74837 8.38091 6.76132 8.44165 6.78648C8.50239 6.81164 8.55758 6.84851 8.60407 6.895C8.65055 6.94149 8.68743 6.99668 8.71259 7.05742C8.73775 7.11816 8.7507 7.18326 8.7507 7.249C8.7507 7.31474 8.73775 7.37984 8.71259 7.44058C8.68743 7.50132 8.65055 7.55651 8.60407 7.603"
						fill="#E37056"
					/>
				</svg>
				<div class="notify">Thu hồi thông báo</div>
			</div>
			<button
				v-if="
					!isEdit &&
					notification.state === 'sent' &&
					notification.unread_count > 0
				"
				type="button"
				class="button-p text-center w-fit px-10"
				@click="confirmReSendOpen"
			>
				Gửi lại thông báo
			</button>
		</div>
		<div
			class="bg-white rounded-xl p-6 shadow-sm mt-10"
			v-if="notification.state === 'draft'"
		>
			<div class="rounded-lg p-4 border border-gray-100 mt-4">
				<div class="flex md-down:flex-col w-full gap-4">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						gửi lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification?.sent_at">
							{{ $filters.formatDateTime(notification?.sent_at) }}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						tạo lúc
					</div>
					<div class="w-full text-gray-700">
						<div v-if="notification?.inserted_at">
							{{
								$filters.formatDateTime(
									notification?.inserted_at
								)
							}}
						</div>
						<div v-else>-</div>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-60"
					>
						người gửi
					</div>
					<div class="w-full text-gray-700">
						<div
							v-if="notification.sent_by_staff"
							@click="
								isAdmin &&
									$router.push(
										`/record/employee/${notification.sent_by_staff.id}`
									)
							"
							:class="{
								'cursor-pointer': isAdmin,
							}"
						>
							<div class="flex items-center">
								<img
									class="shadow-sm inline-block h-6 w-6 rounded-full"
									:src="
										notification.sent_by_staff
											?.profile_photo?.w200
									"
									v-if="
										notification.sent_by_staff
											?.profile_photo?.w200
									"
									alt=""
								/>
								<span
									v-else
									class="inline-flex items-center justify-center h-6 w-6 rounded-full"
									:style="{
										background:
											notification.sent_by_staff
												?.profile_photo?.default?.color,
									}"
								>
									<span
										class="font-medium leading-none text-white text-xs"
										>{{
											notification.sent_by_staff
												?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div class="ml-4 text-blue-600 font-semibold">
									{{ notification.sent_by_staff?.name }}
								</div>
							</div>
						</div>
						<div v-else>-</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div
				class="text-lg text-neutral-600 font-semibold my-6"
				v-if="notification.is_notice_for_parent"
			>
				Danh sách
				{{ !notification.is_notice_for_parent ? $filters.terminology('teacher_short_name') : 'phụ huynh' }}
				nhận được thông báo
			</div>
			<div
				class="shadow-sm sm:rounded-2xl"
				v-if="notification.is_notice_for_parent"
			>
				<div class="__record__table overflow-x-auto scroll-bar">
					<div
						class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
					>
						<table class="min-w-full divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										scope="col"
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
									>
										STT
									</th>
									<th
										scope="col"
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-32"
									>
										Tên học sinh
									</th>
									<th
										scope="col"
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Mô hình
									</th>
									<th
										scope="col"
										class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										{{
											notification.is_notice_for_parenti
												? $filters.terminology('teacher_short_name')
												: 'Phụ Huynh'
										}}
										đã xem
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(person, personIdx) in parents"
									:key="person.id"
									:class="
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="text-neutral-700"
								>
									<td>
										<div class="px-6 py-4 text-neutral-700">
											{{ personIdx + 1 }}
										</div>
									</td>
									<td
										class="px-6 py-4 whitespace-nowrap text-neutral-700"
									>
										<div
											style="width: 400px"
											class="flex items-center"
											@click="
												$router.push(
													`/record/student/${person.id}/info`
												)
											"
										>
											<div>
												<img
													class="shadow-sm inline-block h-6 w-6 rounded-full"
													:src="
														person?.profile_photo
															?.w200
													"
													alt=""
													v-if="
														person?.profile_photo
															?.w200
													"
												/>
												<span
													v-else
													class="inline-flex items-center justify-center h-6 w-6 rounded-full"
													:style="{
														background:
															person
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="font-medium leading-none text-white text-xs"
														>{{
															person
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
											</div>
											<div
												class="ml-4 text-orange-600 font-semibold"
											>
												{{ person.name }}
											</div>
										</div>
									</td>
									<td
										class="px-6 py-4 whitespace-nowrap text-neutral-700"
									>
										<div class="flex items-center">
											<svg
												v-if="person.has_personal_class"
												width="36"
												height="36"
												viewBox="0 0 36 36"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7506 11.2911V10.4867C11.7506 10.3699 11.7276 10.2543 11.6829 10.1465C11.6733 10.1234 11.6628 10.1008 11.6514 10.0787C11.6372 10.051 11.6215 10.0242 11.6044 9.99829C11.5842 9.96762 11.5622 9.93817 11.5383 9.9102C11.523 9.89224 11.507 9.87485 11.4902 9.85811C11.4077 9.77556 11.3097 9.7101 11.2019 9.66545C11.094 9.62079 10.9784 9.5978 10.8617 9.5978H9.77724C9.77724 9.17401 9.9456 8.76762 10.2452 8.46799C10.5449 8.16836 10.9513 8 11.375 8H25.9573C26.1671 8 26.3748 8.04135 26.5687 8.12161C26.7625 8.20192 26.9386 8.31962 27.087 8.46799C27.2354 8.61635 27.3531 8.79249 27.4334 8.98633C27.5137 9.18017 27.555 9.38794 27.555 9.5978V26.4022C27.555 26.6121 27.5137 26.8198 27.4334 27.0137C27.3531 27.2075 27.2354 27.3836 27.087 27.532C26.9386 27.6804 26.7625 27.7981 26.5687 27.8784C26.3748 27.9586 26.1671 28 25.9573 28H11.375C10.9513 28 10.5449 27.8316 10.2452 27.532C9.9456 27.2324 9.77724 26.826 9.77724 26.4022H10.8617C10.9784 26.4022 11.094 26.3792 11.2019 26.3346C11.3097 26.2899 11.4077 26.2244 11.4902 26.1419C11.5728 26.0593 11.6383 25.9613 11.6829 25.8535C11.7276 25.7457 11.7506 25.6301 11.7506 25.5133V24.7089C11.7506 24.5922 11.7276 24.4766 11.6829 24.3687C11.6383 24.2609 11.5728 24.1629 11.4902 24.0803C11.4587 24.0488 11.4249 24.0197 11.3891 23.9934C11.3313 23.9508 11.2685 23.9152 11.2019 23.8877C11.094 23.843 10.9784 23.82 10.8617 23.82H9.77724V22.8466H10.8617C10.9784 22.8466 11.094 22.8237 11.2019 22.779C11.3097 22.7343 11.4077 22.6689 11.4902 22.5863C11.5728 22.5038 11.6383 22.4058 11.6829 22.2979C11.6893 22.2825 11.6953 22.267 11.7008 22.2513C11.7129 22.2166 11.7228 22.1812 11.7306 22.1454C11.7391 22.1058 11.745 22.0656 11.7481 22.0252C11.7497 22.0028 11.7506 21.9803 11.7506 21.9578V21.1533C11.7506 21.0366 11.7276 20.921 11.6829 20.8132C11.6739 20.7912 11.6639 20.7697 11.6532 20.7487C11.6401 20.7232 11.6259 20.6984 11.6105 20.6744C11.5831 20.6316 11.5521 20.5911 11.5178 20.5536C11.5088 20.5438 11.4997 20.5342 11.4902 20.5248C11.4556 20.4901 11.4182 20.4585 11.3785 20.4301C11.3237 20.3909 11.2644 20.358 11.2019 20.3321C11.094 20.2874 10.9784 20.2645 10.8617 20.2645H9.77724V19.2911H10.8617C10.9784 19.2911 11.094 19.2681 11.2019 19.2234C11.3097 19.1788 11.4077 19.1133 11.4902 19.0308C11.5728 18.9482 11.6383 18.8502 11.6829 18.7424C11.7276 18.6346 11.7506 18.519 11.7506 18.4022V17.5978C11.7506 17.481 11.7276 17.3654 11.6829 17.2576C11.6383 17.1498 11.5728 17.0518 11.4902 16.9692C11.4077 16.8867 11.3097 16.8212 11.2019 16.7766C11.094 16.7319 10.9784 16.7089 10.8617 16.7089H9.77724V15.7355H10.8617C10.9784 15.7355 11.094 15.7126 11.2019 15.6679C11.3097 15.6232 11.4077 15.5577 11.4902 15.4752C11.5728 15.3927 11.6383 15.2947 11.6829 15.1868C11.7118 15.1172 11.7316 15.0442 11.742 14.9699C11.7447 14.9508 11.7467 14.9318 11.7482 14.9126C11.7498 14.8907 11.7506 14.8687 11.7506 14.8467V14.0422C11.7506 13.9255 11.7276 13.8099 11.6829 13.7021C11.6383 13.5942 11.5728 13.4962 11.4902 13.4137C11.4077 13.3311 11.3097 13.2657 11.2019 13.221C11.1489 13.199 11.094 13.1823 11.038 13.171C10.9801 13.1593 10.921 13.1534 10.8617 13.1534H9.77724V12.18H10.8617C10.9784 12.18 11.094 12.157 11.2019 12.1123C11.3097 12.0677 11.4077 12.0022 11.4902 11.9197C11.5728 11.8371 11.6383 11.7391 11.6829 11.6313C11.7276 11.5234 11.7506 11.4078 11.7506 11.2911ZM10.8627 10.2648H8.66655C8.54382 10.2648 8.44434 10.3643 8.44434 10.487V11.2908C8.44434 11.4135 8.54382 11.513 8.66655 11.513H10.8627C10.9854 11.513 11.0849 11.4135 11.0849 11.2908V10.487C11.0849 10.3643 10.9854 10.2648 10.8627 10.2648ZM8.66655 17.3759H10.8627C10.9854 17.3759 11.0849 17.4754 11.0849 17.5981V18.4019C11.0849 18.5246 10.9854 18.6241 10.8627 18.6241H8.66655C8.54382 18.6241 8.44434 18.5246 8.44434 18.4019V17.5981C8.44434 17.4754 8.54382 17.3759 8.66655 17.3759ZM10.8627 13.8204H8.66655C8.61717 13.8204 8.57154 13.8365 8.53467 13.8637C8.47989 13.9042 8.44434 13.9692 8.44434 14.0426V14.8464C8.44434 14.9691 8.54382 15.0686 8.66655 15.0686H10.8627C10.9854 15.0686 11.0849 14.9691 11.0849 14.8464V14.0426C11.0849 13.9199 10.9854 13.8204 10.8627 13.8204ZM10.8627 20.9315H8.66655C8.54382 20.9315 8.44434 21.031 8.44434 21.1537V21.9575C8.44434 22.0802 8.54382 22.1797 8.66655 22.1797H10.8627C10.9854 22.1797 11.0849 22.0802 11.0849 21.9575V21.1537C11.0849 21.031 10.9854 20.9315 10.8627 20.9315ZM10.8627 24.487H8.66655C8.54382 24.487 8.44434 24.5865 8.44434 24.7092V25.513C8.44434 25.6358 8.54382 25.7352 8.66655 25.7352H10.8627C10.9854 25.7352 11.0849 25.6358 11.0849 25.513V24.7092C11.0849 24.5865 10.9854 24.487 10.8627 24.487ZM22.9997 15.9167C22.9997 17.9877 21.3208 19.6667 19.2497 19.6667C17.1786 19.6667 15.4997 17.9877 15.4997 15.9167C15.4997 13.8456 17.1786 12.1667 19.2497 12.1667C21.3208 12.1667 22.9997 13.8456 22.9997 15.9167ZM25.4997 23.1108C25.4997 23.1108 24.2497 20.9167 19.2497 20.9167C14.2497 20.9167 12.9997 23.1109 12.9997 23.1109V23.4167C12.9997 24.107 13.5593 24.6667 14.2497 24.6667H24.2497C24.9401 24.6667 25.4997 24.107 25.4997 23.4167V23.1108Z"
													fill="#F1A267"
												/>
											</svg>
											<svg
												v-if="person.has_day_care_class"
												width="36"
												height="36"
												viewBox="0 0 36 36"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M13.9967 28C14.214 27.9999 14.4291 27.9559 14.629 27.8706C14.829 27.7854 15.0096 27.6607 15.1602 27.5039C15.3108 27.3472 15.4282 27.1617 15.5054 26.9585C15.5825 26.7553 15.6179 26.5386 15.6093 26.3214L15.3391 17.8825L16.5167 17.1728C16.8171 16.9908 17.0636 16.732 17.2308 16.423C17.398 16.1141 17.4799 15.7662 17.468 15.4152L17.2329 8.61745C17.2272 8.45347 17.1581 8.29811 17.04 8.18416C16.922 8.0702 16.7643 8.00656 16.6002 8.00666C16.4369 8.00828 16.2805 8.07298 16.1638 8.18723C16.0471 8.30147 15.9791 8.45641 15.974 8.61964L15.8092 12.8556C15.8078 12.9819 15.7611 13.1034 15.6777 13.1981C15.5942 13.2929 15.4795 13.3546 15.3544 13.3719C15.285 13.3795 15.2147 13.3727 15.148 13.3518C15.0812 13.331 15.0195 13.2966 14.9667 13.2508C14.9139 13.205 14.8712 13.1488 14.8411 13.0857C14.811 13.0226 14.7943 12.954 14.792 12.8842L14.6272 8.64381C14.6233 8.49838 14.5715 8.35831 14.4797 8.24544C14.3879 8.13258 14.2613 8.05326 14.1197 8.01984C14.0353 8.00563 13.9492 8.00563 13.8648 8.01984C13.7232 8.05326 13.5967 8.13258 13.5049 8.24544C13.4131 8.35831 13.3612 8.49838 13.3573 8.64381L13.1925 12.8842C13.1902 12.954 13.1735 13.0226 13.1434 13.0857C13.1134 13.1488 13.0706 13.205 13.0178 13.2508C12.965 13.2966 12.9033 13.331 12.8366 13.3518C12.7699 13.3727 12.6996 13.3795 12.6301 13.3719C12.505 13.3546 12.3903 13.2929 12.3069 13.1981C12.2234 13.1034 12.1767 12.9819 12.1753 12.8556L12.0039 8.61964C11.9987 8.45336 11.9283 8.2958 11.8078 8.18108C11.6873 8.06635 11.5265 8.00369 11.3602 8.00666C11.1961 8.00656 11.0384 8.0702 10.9203 8.18416C10.8023 8.29811 10.7331 8.45347 10.7274 8.61745L10.5011 15.4174C10.4893 15.7684 10.5712 16.1163 10.7384 16.4252C10.9056 16.7342 11.1521 16.993 11.4525 17.175L12.6521 17.8957L12.3818 26.3214C12.3732 26.5388 12.4087 26.7557 12.486 26.959C12.5633 27.1623 12.6808 27.3479 12.8317 27.5047C12.9825 27.6615 13.1634 27.7862 13.3636 27.8713C13.5638 27.9564 13.7791 28.0002 13.9967 28Z"
													fill="#F1A267"
												/>
												<path
													d="M25.8125 16.2457C26.1252 15.6708 26.287 15.026 26.2827 14.3716C26.2673 12.2207 25.8784 8.02206 22.7872 8.00009C19.6959 7.97811 19.307 12.2119 19.2916 14.3716C19.2866 15.0258 19.4477 15.6706 19.7596 16.2457C20.0901 16.8558 20.5779 17.3663 21.1723 17.7243L21.4623 17.9001L21.1943 26.3214C21.1863 26.5355 21.2216 26.7489 21.298 26.9489C21.3744 27.149 21.4904 27.3316 21.639 27.4858C21.7876 27.64 21.9658 27.7627 22.1629 27.8465C22.3599 27.9303 22.5719 27.9735 22.7861 27.9735C23.0002 27.9735 23.2122 27.9303 23.4093 27.8465C23.6063 27.7627 23.7845 27.64 23.9331 27.4858C24.0817 27.3316 24.1977 27.149 24.2741 26.9489C24.3505 26.7489 24.3858 26.5355 24.3778 26.3214L24.1032 17.8957L24.3932 17.7199C24.9894 17.364 25.4795 16.855 25.8125 16.2457Z"
													fill="#F1A267"
												/>
											</svg>
										</div>
									</td>
									<td
										class="px-6 py-4 whitespace-nowrap"
										style="width: 300px"
									>
										<div
											class="flex-nowrap flex items-center"
											v-if="person.read_by_parent"
										>
											<svg
												width="20"
												height="20"
												viewBox="0 0 20 20"
												fill="none"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34673 11.7709L6.72983 9.15403C6.36372 8.78791 5.77012 8.78791 5.40401 9.15403C5.03789 9.52015 5.03789 10.1137 5.40401 10.4799L8.71207 13.7879C9.07818 14.154 9.67178 14.154 10.0379 13.7879C10.046 13.7798 10.0537 13.7712 10.0609 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209Z"
													fill="#41BEAD"
												/>
											</svg>
											<div class="text-neutral-500 ml-4">
												Đã xem
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 flex items-center justify-center md:justify-end"
			v-if="!isEdit && notification.state === 'draft'"
		>
			<button
				type="button"
				class="button-p text-center w-fit px-10"
				@click="confirmSendOpen"
				:disabled="inProgress"
			>
				Gửi thông báo
			</button>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import DeleteConfirm from './features/DeleteConfirm';
import { ACTIONS } from '@/enums/Common';
import ConfirmSend from '@/views/notificationDetail/features/ConfirmSend';
import ReSend from '@/views/notificationDetail/features/ReSend';
import Withdraw from '@/views/notificationDetail/features/Withdraw';
import Multiselect from '@suadelabs/vue3-multiselect';
import { formatUrl } from '@/helper/formatUrl';
import ViewPhoto from '@/components/common/ViewPhoto';

export default {
	name: 'NotificationCreate',
	components: {
		ConfirmSend,
		DeleteConfirm,
		DaModalFrame,
		Multiselect,
		ViewPhoto,
		ReSend,
		Withdraw,
	},
	data() {
		return {
			modalIsOpen: false,
			modalType: false,
			notification: {
				content: '',
				inserted_at: '',
				sent_at: null,
				sent_by_staff: null,
				state: '',
				subject: '',
				title: '',
				view_count: 0,
				attachment_photo: '',
				attachment_file: null,
			},
			isEdit: false,
			target: null,
			boardings: [],
			title: '',
			file: null,
			files: [],
			images: [],
			parents: [],
			keys: [],
			inProgress: false,
			imageShow: false,
			photosIndex: 0,
			open: false,
			targetGroup: 'parents',
			targetCustom: null,
			staffsSelected: [],
			parentsSelected: [],
			students: [],
			staffs: [],
		};
	},
	watch: {
		target() {
			this.staffsSelected = [];
			this.parentsSelected = [];
		},
		targetGroup() {
			this.target = null;
			this.staffsSelected = [];
			this.parentsSelected = [];
		},
	},
	computed: {
		id() {
			return this.$route.params.id || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		type() {
			return ACTIONS;
		},

		isImageType() {
			return this.file ? this.file.type.includes('image/') : '';
		},

		targetOptions() {
			if (this.targetGroup === 'staffs') {
				return [
					{
						value: 'all_staffs_in_org',
						text: `${this.$filters.terminology('teacher')} toàn cơ sở`,
					},
					{
						value: 'all_day_care_staffs',
						text: `${this.$filters.terminology('teacher')} bán trú`,
					},
					{
						value: 'all_assigned_staffs',
						text: `${this.$filters.terminology('teacher')} can thiệp cá nhân`,
					},
					{
						value: 'custom_staffs',
						text: 'Tuỳ chọn',
					},
				];
			}
			let targetOptions = [
				{
					value: 'all_parents_in_org',
					text: 'PH toàn cơ sở',
				},
			];
			let dayCare = this.boardings.map((item) => {
				return {
					value: item.id,
					text: 'PH lớp ' + item.name,
				};
			});
			return [
				...targetOptions,
				...dayCare,
				{
					value: 'custom_parent_of_students',
					text: 'Tuỳ chọn',
				},
			];
		},
		targetOptionsCustom() {
			const sId = this.staffsSelected.map((item) => item.value);
			const pId = this.parentsSelected.map((item) => item.value);
			if (this.targetGroup === 'staffs') {
				return this.staffs
					.map((item) => {
						return {
							value: item.id,
							text: item.name,
						};
					})
					.filter((item) => !sId.includes(item.value));
			}
			return this.students
				.map((item) => {
					return {
						value: item.id,
						text: 'PH bé ' + item.name,
					};
				})
				.filter((item) => !pId.includes(item.value));
		},
	},

	created() {
		this.fetchStudents();
		this.fetchStaffs();
		this.fetchBoardings();
		this.fetchNotification();
		this.fetchParentReadNotification();
	},

	methods: {
		formatUrl,
		customSelected(value) {
			this.targetCustom = null;
			if (this.targetGroup === 'staffs') {
				const index = this.staffsSelected.indexOf(value);
				if (index !== -1) {
					this.staffsSelected.splice(index, 1);
				} else {
					this.staffsSelected.push(value);
				}
			} else {
				const index = this.parentsSelected.indexOf(value);
				if (index !== -1) {
					this.parentsSelected.splice(index, 1);
				} else {
					this.parentsSelected.push(value);
				}
			}
		},

		deleteSelected(value) {
			if (this.targetGroup === 'staffs') {
				const index = this.staffsSelected.indexOf(value);
				if (index !== -1) {
					this.staffsSelected.splice(index, 1);
				}
			} else {
				const index = this.parentsSelected.indexOf(value);
				if (index !== -1) {
					this.parentsSelected.splice(index, 1);
				}
			}
		},
		async fetchBoardings() {
			try {
				const res = await $api.boarding.getDayCareClasses();
				this.boardings = res?.data?.data || [];
			} catch (err) {
				console.log(err);
			}
		},

		async fetchNotification() {
			try {
				const res = await $api.notification.getNotification(this.id);
				this.notification = res?.data?.data;
				if (this.notification?.is_notice_for_parent)
					this.targetGroup = 'parents';
				else this.targetGroup = 'staffs';
				this.title = this.notification.title;
				this.files =
					this.notification?.notice_attachments?.filter(
						(i) => !i.is_image
					) || [];
				this.images =
					this.notification?.notice_attachments?.filter(
						(i) => i.is_image
					) || [];
				if (
					this.notification?.attachment_photo &&
					this.notification?.attachment_photo?.w1000
				) {
					this.images.push({
						id: this.notification?.attachment_photo?.w1000,
						asset_key: this.notification?.attachment_photo?.w1000,
						asset_url: this.notification?.attachment_photo?.w1000,
					});
				}
				if (
					this.notification?.attachment_file &&
					this.notification?.attachment_file?.file?.original
				) {
					this.files.push({
						id: this.notification?.attachment_file?.file?.original,
						asset_key:
							this.notification?.attachment_file?.file?.original,
						asset_url:
							this.notification?.attachment_file?.file?.original,
						name: this.notification?.attachment_file?.file_name,
					});
				}
				if (this.notification?.students.length > 0) {
					this.parentsSelected = this.notification?.students.map(
						(item) => {
							return {
								value: item.id,
								text: 'PH bé ' + item.name,
							};
						}
					);
				}
				if (this.notification?.staffs.length > 0) {
					this.staffsSelected = this.notification?.staffs.map(
						(item) => {
							return {
								value: item.id,
								text: item.name,
							};
						}
					);
				}
			} catch (err) {
				console.log(err);
			}
		},

		async fetchParentReadNotification() {
			try {
				const {
					data: { data },
				} = await $api.notification.getParentReadNotification(this.id);
				this.parents = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async deleteNotification() {
			this.inProgress = true;
			try {
				await $api.notification.deleteNotification(this.id);
				await this.$router.push('/notifications');
				this.$store.dispatch('setAlertMessage', {
					message: 'Xoá mới thông báo thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		async sendNotification() {
			this.inProgress = true;
			try {
				await $api.notification.sendNotification(this.id);
				this.cancel();
				await this.fetchNotification();
				this.$store.dispatch('setAlertMessage', {
					message: 'Gửi thông báo thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},
		async resendNotification() {
			this.inProgress = true;
			try {
				await $api.notification.resendNotification(this.id);
				this.cancel();
				await this.fetchNotification();
				this.$store.dispatch('setAlertMessage', {
					message: 'Thông báo đã được gửi lại thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},
		async withdrawNotification() {
			this.inProgress = true;
			try {
				await $api.notification.withdrawNotification(this.id);
				this.cancel();
				await this.fetchNotification();
				this.$store.dispatch('setAlertMessage', {
					message: 'Thông báo đã được thu hồi thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		isImage(icon) {
			const ext = ['.jpg', '.jpeg', '.png', '.svg'];
			return ext.some((el) => icon.toLowerCase().endsWith(el));
		},

		async getSignatures() {
			const fileList = [...this.images, ...this.files];
			let arr = [];
			fileList.forEach((file) => {
				if (!file.asset_key) {
					arr.push(file);
				}
			});
			const {
				data: { data },
			} = await this.$api.file.getSignatures({
				mime_types: arr.map((i) => i.type),
				prefix: 'notice_attachment',
			});

			if (data && data.length) {
				for (let i = 0; i < data.length; i++) {
					let formData = new FormData();
					formData.append(
						'AWSAccessKeyId',
						data[0]['AWSAccessKeyId'] || ''
					);
					formData.append('key', data[i].key || '');
					formData.append('acl', data[i].acl || '');
					formData.append(
						'Content-Type',
						data[i]['Content-Type'] || ''
					);
					formData.append('x-amz-signature', data[i].signature || '');
					formData.append('Signature', data[i].signature || '');
					formData.append('Policy', data[i].policy || '');
					formData.append(
						'success_action_status',
						data[i].success_action_status || ''
					);
					formData.append('file', arr[i]);
					await this.uploadToS3(data[i].action, formData, arr[i]);
				}
			}
		},

		async uploadToS3(url, payload, file) {
			const { data } = await this.$api.file.uploadToS3(url, payload);
			const keyData = data.toString().match('<Key>(.*)</Key>');
			const key = keyData && keyData.length ? keyData[1] : '';
			if (key) {
				this.keys.push({
					asset_key: key,
					mime_type: file.type,
					name: file.name,
				});
			}
		},

		async update() {
			this.inProgress = true;
			try {
				if (this.images.length > 0 || this.files.length > 0) {
					await this.getSignatures();
				}
				const payload = {
					title: this.notification.title,
					content: this.notification.content,
					notice_attachments: this.keys,
					day_care_class_id: ![
						'all_parents_in_org',
						'is_all_staffs_in_org',
						'all_staffs_in_org',
						'custom_parent_of_students',
						'custom_staffs',
						'all_assigned_staffs',
						'all_day_care_staffs',
					].includes(this.target?.value)
						? this.target?.value
						: '',
					subject: [
						'all_parents_in_org',
						'is_all_staffs_in_org',
						'all_staffs_in_org',
						'custom_parent_of_students',
						'custom_staffs',
						'all_assigned_staffs',
						'all_day_care_staffs',
					].includes(this.target?.value)
						? this.target?.value
						: '',
					custom_staff_or_student_id_list:
						this.targetGroup === 'staffs'
							? this.staffsSelected.map((s) => s.value)
							: this.parentsSelected.map((s) => s.value),
					is_all_parent_in_org:
						this.target &&
						(this.target.value === null ||
							this.target?.value === 'all')
							? 'true'
							: 'false',
				};
				await $api.notification.updateNotification(this.id, payload);
				this.isEdit = false;
				await this.fetchNotification();
				this.$store.dispatch('setAlertMessage', {
					message: 'Thêm mới thông báo thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},
		edit() {
			this.isEdit = true;
			this.target = {
				value: this.notification.raw_subject,
				text: this.notification.subject,
			};
		},
		confirmWithdrawOpen() {
			this.open = true;
		},
		deleteOpen() {
			this.modalIsOpen = true;
			this.modalType = this.type.DELETE;
		},

		confirmSendOpen() {
			this.modalIsOpen = true;
			this.modalType = this.type.CREATE;
		},
		confirmReSendOpen() {
			this.modalIsOpen = true;
			this.modalType = this.type.RESEND;
		},

		cancel() {
			this.modalIsOpen = false;
			this.modalType = '';
			this.open = false;
		},

		openModelUpload() {
			const target = document.getElementById(
				'upload-images-notification-detail'
			);
			target ? target.click() : '';
		},

		uploadChange(event) {
			let fileUploads = Array.from(event?.target?.files || []);
			if (!fileUploads || !fileUploads.length) {
				return;
			}
			fileUploads.forEach((file) => {
				if (this.isImage(file.name)) {
					this.images.push(file);
				} else {
					this.files.push(file);
				}
			});
			this.closeUpload();

			// let file = event?.target?.files[0];

			// if (!file) {
			// 	return;
			// }

			// if (!this.isImage(file.name)) {
			// 	this.$store.dispatch('setAlertMessage', {
			// 		message: 'Định dạng ảnh không đúng. (JPG, JPEG, SVG, PNG)',
			// 		type: 'danger',
			// 	});
			// 	return;
			// }

			// if (file) {
			// 	this.file = file;
			// 	this.fileUrl = URL.createObjectURL(this.file);
			// 	this.closeUpload();
			// }
		},

		closeUpload() {
			const target = document.getElementById(
				'upload-images-notification-detail'
			);
			target ? (target.value = null) : '';
		},

		removeImage() {
			this.file = null;
			this.fileUrl = '';
		},
		removeFile(index) {
			this.files.splice(index, 1);
		},

		getUrl(file) {
			if (!file || file?.asset_url) {
				return file?.asset_url ?? '';
			}

			return URL.createObjectURL(file);
		},
		openMediaPopup(index) {
			this.imageShow = true;
			this.photosIndex = index;
		},
		async fetchStudents() {
			let role =
				this.$store.state.profile.staff.role === 'teacher'
					? 'staff'
					: 'org_admin';
			try {
				const {
					data: { data },
				} = await $api.student.getStudents(role, '');
				this.students = data;
			} catch (err) {
				console.log(err);
			}
		},

		async fetchStaffs() {
			try {
				const {
					data: { data },
				} = await $api.staff.getEmployees('');
				this.staffs = data;
			} catch (err) {
				console.log(err);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.title {
	font-weight: 600;
	box-shadow: none !important;

	&::placeholder {
		font-weight: normal;
	}
}
.notify {
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: #db5a41;
}
</style>
